import { authInstance, HttpUtils } from "../http-common";

const register = (username, password) => {
    return authInstance.post("/register", {
        username,
        password,
    });
};

const login = (username, password) => {
    return authInstance.post("/login", {
        username,
        password,
    })
        .then((response) => {
            if (response.data.accessToken && response.data.role !== "ad") {
                localStorage.setItem("user", JSON.stringify(response.data));
            } else {
                return false;
            }

            return response.data;
        });
};

const changePassword = (username, password) => {
    return authInstance.post("/changePassword", {
        username,
        password,
    })
        .then((response) => {
            if (response.data.accessToken) {
                localStorage.setItem("user", JSON.stringify(response.data));
            }

            return response.data;
        });
};

const forgotPassword = (username) => {
    return authInstance.post("/forgotPasswordBackend", {
        username
    })
        .then((response) => {

            return response.data;
        });
};

const resetPassword = (token, password) => {
    return authInstance.post(`/resetPassword/${token}`, {
        token,
        password
    })
        .then((response) => {
            return response.data;
        });
};

const loginSchulung = (password) => {
    return authInstance.post("/loginSchulung", {
        password
    })
        .then((response) => {

            return response.data;
        });
};

const profile = (email, birthdate) => {
    return authInstance.post("/profile", {
        email,
        birthdate,
    })
        .then((response) => {

            return response.data;
        });
};

const logout = () => {
    HttpUtils.logout();
};

const getCurrentUser = () => {
    return JSON.parse(localStorage.getItem("user"));
};

const isLoggedIn = () => {
    return !!localStorage.getItem("user")

}

const refreshToken = async () => {
    try {
        return await HttpUtils.refreshToken();
    } catch (error) {
        console.error("Token-Aktualisierung fehlgeschlagen", error);
        return null;
    }
}

const isAdmin = () => {
    return HttpUtils.isAdmin();
}

const isSupport = () => {
    const user = getCurrentUser();
    return user?.role === "support";
}

const isRecruiting = () => {
    const user = getCurrentUser();
    return user?.role === "recruiting";
}

const AuthService = {
    register,
    profile,
    isLoggedIn,
    changePassword,
    refreshToken,
    forgotPassword,
    resetPassword,
    isAdmin,
    isSupport,
    isRecruiting,
    login,
    loginSchulung,
    logout,
    getCurrentUser
}
export default AuthService
